import React from 'react'
import Footer from '../components/Footer/Footer'
import './pagestyles/Biography.css'

function Biography() {
  return (
    <div> 
        <div className='bioBox textStyle'>
            <h1>
                Life in God is Art (𝖤𝖼𝖼𝗅 3:11)
            </h1>
            <p>
                ˗ˏˋ ✞ ˎˊ˗ 𝔄ℜ𝔱ist + Prod. cr .
            </p>
            <p>
                My name is “Kushim” meaning “peace,” my desire is to introduce you to the Prince of Peace, Jesus Christ. (Isaiah 9:6)
            </p>
            <p>
                I'm a Godly Creative, an Independent Artist, Producer, Sound Engineer as well as a Software Developer from Namibia (originally from Nigeria), &amp; I create all my music & art with guidance from the Holy Spirit for your spiritual edification 🧡
            </p>
            <p>WELCOME TO THE "PEACE TRiBE” ◑</p>
        </div>
        <Footer/>
    </div>
  )
}

export default Biography